import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StatisticsModalType } from './statisticsLib';
import { CalculationStatisticClusterType } from '@ydistri/api-sdk';

export interface CalculationsSliceState {
  modalOpened?: StatisticsModalType;
  departmentId?: number;
  clusterType: CalculationStatisticClusterType;
}

const initialState: CalculationsSliceState = {
  modalOpened: undefined,
  departmentId: undefined,
  clusterType: CalculationStatisticClusterType.StoreDepartment,
};

export const statisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    setDepartmentId: (state, action: PayloadAction<number | undefined>) => {
      state.departmentId = action.payload;
    },
    setClusterType: (state, action: PayloadAction<CalculationStatisticClusterType>) => {
      state.clusterType = action.payload;
    },
    openStatisticsModal: (state, action: PayloadAction<StatisticsModalType>) => {
      state.modalOpened = action.payload;
    },
    closeStatisticsModal: state => {
      state.modalOpened = undefined;
    },
    resetState: () => initialState,
  },
});

export const { setDepartmentId, setClusterType, openStatisticsModal, closeStatisticsModal } =
  statisticsSlice.actions;

export const statisticsReducer = statisticsSlice.reducer;
